export const QC_INCIDENT_QUERY_PARAM = "incident";

/** Present only for read-only open. Resolve stays the default when this param is absent. */
export const QC_INCIDENT_MODE_QUERY_PARAM = "mode";

export type QcIncidentOpenMode = "view" | "resolve" | "loan";

export function readQcIncidentOpenMode(params: URLSearchParams): QcIncidentOpenMode {
  const mode = params.get(QC_INCIDENT_MODE_QUERY_PARAM);
  if (mode === "view" || mode === "loan") {
    return mode;
  }
  return "resolve";
}

export function writeQcIncidentOpenMode(params: URLSearchParams, mode: QcIncidentOpenMode | null): void {
  if (mode === "view" || mode === "loan") {
    params.set(QC_INCIDENT_MODE_QUERY_PARAM, mode);
    return;
  }
  params.delete(QC_INCIDENT_MODE_QUERY_PARAM);
}

export const QC_INCIDENT_HUB_MODULE_KEYS = ["manufacturing", "quality"] as const;

export type QcIncidentNavHome = (typeof QC_INCIDENT_HUB_MODULE_KEYS)[number];

export function qcIncidentHomeFromPathname(pathname: string): QcIncidentNavHome {
  return pathname.startsWith("/quality") ? "quality" : "manufacturing";
}

export function qcIncidentListPath(home: QcIncidentNavHome = "manufacturing"): string {
  return home === "quality" ? "/quality/qc-incidents" : "/manufacturing/qc-incidents";
}

export function qcIncidentPath(incidentId: number, home: QcIncidentNavHome = "manufacturing"): string {
  return `${qcIncidentListPath(home)}?${QC_INCIDENT_QUERY_PARAM}=${incidentId}`;
}

/** Matches operator-facing copy such as "QC incident #9924". */
export const QC_INCIDENT_MESSAGE_SEGMENT_PATTERN = /(QC incident #\d+)/gi;
